export const blendColor = (opacity: number, bg: string) => {
  const initialOpacity = opacity * 100;

  return `color-mix(in srgb, currentColor ${initialOpacity}%, ${bg} ${100 - initialOpacity}%)`;
};
